import { render, staticRenderFns } from "./DuplicacionOtroIngreso.vue?vue&type=template&id=58fcbef0&scoped=true"
import script from "./DuplicacionOtroIngreso.vue?vue&type=script&lang=ts"
export * from "./DuplicacionOtroIngreso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fcbef0",
  null
  
)

export default component.exports